import Icon from '@components/Icon/Icon';

import styles from './Field.module.scss';

interface AddressFieldProps {
  address: string;
  label?: string;
  size?: 'regular' | 'small' | 'extra-small';
}

const AddressField: React.FC<React.PropsWithChildren<AddressFieldProps>> = ({ address, label, size }) => {
  return (
    <div className={styles['card-field']} data-size={size}>
      <div className={styles['card-item-icon-circle']}>
        <Icon type="address" className={styles['field-icon']} data-size={size} />
      </div>
      <div className={styles['field-data']}>
        <div className={styles['field-data-value']} data-type="address">
          {address}
        </div>
        {label && <div className={styles['field-data-label']}>{label}</div>}
      </div>
    </div>
  );
};

export default AddressField;
